<ng-container *ngFor="let tab of jsonSettings">
  <ng-container [ngSwitch]="tab.type">
    <app-tab-settings *ngSwitchCase="'tab'" [settings]="tab" ></app-tab-settings>
    <app-section-settings *ngSwitchCase="'section'" [settings]="tab" ></app-section-settings>
    <app-field-settings *ngSwitchCase="'field'" [settings]="tab" ></app-field-settings>
  </ng-container>
</ng-container>